import React from "react"
import TranslatorShowcase from "./TalkAndTranslate/TranslatorShowcase"
import TTHeroBanner from "./TalkAndTranslate/TTHeroBanner"
import TestimonialsSection from "./TestimonialsSection"
import TTVideoBanner from "./TalkAndTranslate/TTVideoBanner"
import TTFooterBanner from "./TalkAndTranslate/TTFooterBanner"
import TTTopBg from "./TalkAndTranslate/TTTopBg"
import TTMiddleBg from "./TalkAndTranslate/TTMiddleBg"

const TalkAndTranslatePage = () => {
  return (
    <>
      <TTHeroBanner />
      <TTTopBg />
      <TranslatorShowcase />
      <TTVideoBanner />
      <TestimonialsSection tid="tnt_app_reviews" bgColor="bg-gray_100" />
      <TTFooterBanner />
    </>
  )
}

export default TalkAndTranslatePage